/**
 * How a cost and a ratio are said, for every efficiency surface: the clear,
 * the card and the public page (lib/efficiency.ts has the
 * numbers, lib/strings/efficiency.ts the words).
 *
 * A figure under half a cent is said as "under $0.01" rather than rounded to
 * $0.00: a call that cost something did not cost nothing.
 */
import { useLocale, useStrings } from '../../state/useLocale';
import { oneCent, ratioText, usdFromMicro } from '../../lib/efficiency';

export function useCost(): (micro: number) => string {
  const s = useStrings().efficiency;
  const { locale } = useLocale();
  return (micro) => usdFromMicro(micro, locale) ?? s.under(oneCent(locale));
}

/** "1.4× par", in the reader's language. */
export function useRatio(): (ratio: number) => string {
  const s = useStrings().efficiency;
  const { locale } = useLocale();
  return (ratio) => s.ratio(ratioText(ratio, locale));
}
